import { Link } from 'react-router-dom';
import { AWS_BUCKET_URL } from 'toolkit/constants';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function SportListItem(props) {
  const { to, text, count, itemName, icon, iconUrl } = props;
  const { t } = useTranslation('translations', { useSuspense: false });
  const categoryNames = useSelector((state) => state.match.categoryNames);

  let categoryText = text;

  const code = itemName?.split(':')[2];
  if (t(`categories.${itemName}`) === categoryText && categoryNames) {
    categoryText = categoryNames[itemName];
  }

  if (location.pathname != '/sport' && categoryText && location.pathname != '/results/true') {
    if (categoryText.includes(' ')) {
      categoryText = categoryText.replaceAll(' ', '');
    }
    categoryText = t(`categories.${categoryText}`);
  }

  return (
    <>
      <div className="row">
        <div className="col-1">
          {code ? (
            <div>
              <img
                width="20"
                height="13"
                src={`${AWS_BUCKET_URL}/ClientFlags/${code}.svg`}
                alt={code}
              />
            </div>
          ) : iconUrl ? (
            <div>
              <img width="22" height="22" src={iconUrl} alt={text || icon || 'icon'} className='icon' />
            </div>
          ) : icon ? (
            <div>
              <img width="22" height="22" src={`${AWS_BUCKET_URL}/Icons/${icon}.svg`} alt={icon} className='icon' />
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="col-11">
          <Link to={to}>
            <div className="sportListItem">
              <span className="fs-17">{categoryText}</span>
              <div className="d-flex">
                {count == 0 ? <span></span> : <span className="me-2">{count}</span>}
                <span>
                  <img width="20" height="20" src={`${AWS_BUCKET_URL}/Icons/nexticon-caret.svg`} className='icon'/>
                </span>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <hr className="my-2 line" />
    </>
  );
}

export default SportListItem;
